import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import { MobileNav } from './MobileNav'
import { useUIStore } from '@/stores/uiStore'
import { cn } from '@/lib/utils'

export function AppShell() {
  const { sidebarCollapsed } = useUIStore()

  return (
    <div className="flex h-screen overflow-hidden bg-stone-50">
      {/* Sidebar — desktop only */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      <div
        className={cn(
          'flex flex-1 flex-col overflow-hidden transition-all duration-200',
          sidebarCollapsed ? 'md:ml-15' : 'md:ml-60'
        )}
      >
        <TopBar />
        {/* pb-20 on mobile to clear the fixed bottom nav */}
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 pb-20 md:pb-6 scroll-y">
          <Outlet />
        </main>
      </div>

      {/* Bottom nav — mobile only */}
      <div className="md:hidden">
        <MobileNav />
      </div>
    </div>
  )
}
